module.exports = __webpack_public_path__ + "static/media/operations.3891d0d1.jpg";